module.exports = __webpack_public_path__ + "img/chris1-b.aa163eba.jpg";